import { CourseSubjectType } from "../../../types/CourseSubject";
import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { get } from "../../../utils/axios-config";
import { COURSES_SUBJECTS } from "../../../utils/constants";

export const getCoursesSubjects = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdDepartament ? { IdDepartament: data.IdDepartament } : {}),


    });
    if (data?.IdCourse) {
        queryParams.append('IdCourse', data.IdCourse);
    }
    if (data?.Level) {
        queryParams.append('Level', data.Level.toString());
    }
    if (data?.Semester) {
        queryParams.append('Semester', data.Semester.toString());
    }
    const url = `${COURSES_SUBJECTS}?${queryParams.toString()}`;
    return await get<PagedResultsType<CourseSubjectType>>(url)
};